export const navItems = [
  {
    href: 'apolloEra',
    copy: 'The Apollo Era'
  },
  {
    href: 'contemporaryEra',
    copy: 'The Contemporary Era'
  },
  {
    href: 'artemisEra',
    copy: 'The Artemis Era'
  },
  {
    href: 'theFuture',
    copy: 'The Future'
  }
];
